import React from "react";
import Preloader from "../helper/Preloader";
import HeaderThree from "../components/HeaderThree";
import Breadcrumb from "../components/Breadcrumb";
import ShopSection from "../components/ShopSection";
import Footer from "../components/Footer";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import NewsletterTwo from "../components/NewsletterTwo";

const ShopPage = () => {

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="var(--brand-primary)" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderThree*/}
      <HeaderThree />

      {/* Breadcrumb */}
      <Breadcrumb title={"Shop"} />

      {/* ShopSection */}
      <ShopSection />

      {/* NewsletterTwo */}
      <NewsletterTwo />

      {/* Footer */}
      <Footer />


    </>
  );
};

export default ShopPage;